/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Settings_AssignmentInputs */

const en_task_settings_assignment = /** @type {(inputs: Task_Settings_AssignmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic assignment`)
};

const pt_br2_task_settings_assignment = /** @type {(inputs: Task_Settings_AssignmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atribuição automática`)
};

/**
* | output |
* | --- |
* | "Automatic assignment" |
*
* @param {Task_Settings_AssignmentInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_settings_assignment = /** @type {((inputs?: Task_Settings_AssignmentInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Settings_AssignmentInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_settings_assignment(inputs)
	return pt_br2_task_settings_assignment(inputs)
});